/** Strings owned by the auth area. */
export const AUTH_STRINGS = {
    // ── Step 1: login + password ─────────────────────────────────────────────
    'auth.sign_in_subtitle': { en: 'Sign in to continue', ru: 'Войдите, чтобы продолжить' },
    'auth.login_label': { en: 'Login', ru: 'Логин' },
    'auth.login_placeholder': { en: 'Enter your login', ru: 'Введите логин' },
    'auth.password_label': { en: 'Password', ru: 'Пароль' },
    'auth.password_placeholder': { en: 'Enter your password', ru: 'Введите пароль' },
    'auth.continue': { en: 'Continue', ru: 'Продолжить' },
    'auth.checking': { en: 'Checking…', ru: 'Проверка…' },
    'auth.login_failed': { en: 'Login failed', ru: 'Не удалось войти' },
    'auth.network_error': { en: 'Network error', ru: 'Ошибка сети' },
    // ── Step 2a: TOTP enrolment ──────────────────────────────────────────────
    'auth.totp_setup_title': { en: 'Set up 2FA', ru: 'Настройка 2FA' },
    'auth.totp_setup_subtitle': { en: 'Scan with Google Authenticator, then enter the code', ru: 'Отсканируйте в Google Authenticator и введите код' },
    'auth.qr_alt': { en: 'QR code', ru: 'QR-код' },
    'auth.code_label': { en: '6-digit code', ru: 'Код из 6 цифр' },
    'auth.confirm_sign_in': { en: 'Confirm &amp; Sign in', ru: 'Подтвердить и войти' },
    // ── Step 2b: TOTP verification ───────────────────────────────────────────
    'auth.totp_verify_title': { en: 'Two-factor auth', ru: 'Двухфакторная аутентификация' },
    'auth.totp_verify_subtitle': { en: 'Enter the code from Google Authenticator', ru: 'Введите код из Google Authenticator' },
    'auth.sign_in': { en: 'Sign in', ru: 'Войти' },
    'auth.verifying': { en: 'Verifying…', ru: 'Проверка кода…' },
    'auth.invalid_code': { en: 'Invalid code', ru: 'Неверный код' },
};
